module.exports = __webpack_public_path__ + "img/unicef-1.6fca4a51.svg";